var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fl-button-wrapper",class:{ 'disable': _vm.disable, 'loading': _vm.loading },style:({
     'width': _vm.width + 'px',
     'height': _vm.height + 'px',
     'line-height': _vm.height + 'px',
     'background-color': _vm.bgColor,
     'border-radius': _vm.radius + 'px'
      }),on:{"click":_vm.onClick}},[_c('label',{style:({ 'font-size': _vm.textSize + 'px' })},[_vm._v(_vm._s(_vm.loading ? _vm.loadingText : _vm.text))]),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"k-line k-line11-1"}),_c('div',{staticClass:"k-line k-line11-2"}),_c('div',{staticClass:"k-line k-line11-2"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }